import script from "./PolicyConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicyConfiguration.vue?vue&type=script&setup=true&lang=ts"

import "./PolicyConfiguration.vue?vue&type=style&index=0&id=23e466cd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e466cd"]])

export default __exports__